export default __webpack_public_path__ + "static/media/404.fdd79c4d.webp";